import { generateSubscribedString } from './User'
import Cookies from 'js-cookie'
import u from 'umbrellajs'

let ga = undefined

export default {
  init: GoogleAnalytics,
  create_ga_event: createEvent,
}

export function GoogleAnalytics(site){

  // Initialise google analytics - https://developers.google.com/analytics/devguides/collection/analyticsjs#alternative_async_tag
  window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};
  window.ga.l=+new Date;
  ga = window.ga;

  // Append the GA script to the document in defer mode
  // @NOTE: It's quite possible we don't actually need this because NCA is
  // providing it via GTM
  const $script = u('<script type="text/javascript" src="https://www.google-analytics.com/analytics.js" defer="defer" />')
  u(document).on('DOMContentLoaded', () => {
    u(document.body).append($script)
  })

  // non-finda event tracking - @TODO Should we remove?
  // ga('create', rnn.site.gaSiteCode, 'auto');

  // finda tracking
  ga('create', site.gaFindaCode, 'auto', {'name': 'findaTracker'});

  // Set user
  if (Cookies.get("apn_account_id")) {
    ga('set', 'userId', Cookies.get("apn_account_id"));
  }

  // page view event
  ga('send', 'pageview', setup_rnn_x())
}

export function createEvent(trackData){
  switch(trackData.token){
    case 'subPageEvent':
      return generateSubPageEvent(trackData);
    case 'subModalEvent':
      return generateSubModalEvent(trackData);
    case 'findaEvent':
      return generateFindaEvent(trackData);
    case 'trackEvent':
      return generateTrackEvent(trackData);
    case 'socialEvent':
      return generateSocialEvent(trackData);
    default:
      console.error('Tracking type not found', trackData)
  }
}

// @TODO Cleanup this logic
function setup_rnn_x(){
  var thePageCategories = pageData.categories || '';

  if (thePageCategories.length > 0) {
    thePageCategories = thePageCategories.replace(',', '');
    thePageCategories = thePageCategories.replace(' > ', ':');
    thePageCategories = thePageCategories.toLowerCase();
  }

  var sector = pageData.sector || '',
      subsector = '';

  if (pageData.subsector) {
    subsector = '.' + pageData.subsector;
  }

  var x = {
    'dimension1' : sector + subsector,
    'dimension2' : pageData.pageType,
    'dimension3' : pageData.site,
    'dimension4' : pageData.region || '',
    'dimension5' : thePageCategories,
    'dimension6' : pageData.tags || ''
  };

  var subscribedString = generateSubscribedString();

  x.dimension7 = subscribedString;

  return x;
}

// @TODO cleanup this function
function setup_finda_x(event_type, click_action, data, hitCallback) {
  var ad_classification = (!data.ad_classification) ? "N/A" : data.ad_classification;
  var ad_pillar = (!data.ad_pillar) ? "N/A" : data.ad_pillar;
  var advertiser_booking_id = (!data.advertiser_booking_id) ? "N/A" : data.advertiser_booking_id;

  var x = {
    'dimension1': data.ad_id,                   // Ad ID + Ad Title
    'dimension2': data.ad_advertiser_key,       // AdvertiserID + AdvertiserName
    'dimension3': ad_pillar,                    // Ad Pillar (eg. motoring)
    'dimension4': ad_classification,            // Ad Classification (eg. cars)
    'dimension5': data.ad_advertiser_type,      // Ad Advertiser type (dealer || private)
    'dimension6': data.ad_name,                 // Ad Name/Title
    'dimension7': data.adv_name,                // AdvertiserName
    'dimension8': data.ad_address,              // Address
    'dimension9': generateSubscribedString(),   // staff, etc
    'dimension10': advertiser_booking_id,       // bookingID  (new advertiser id)
    // TODO: when we have the new model that groups advertisers:
    'dimension11': advertiser_booking_id               // Account bookingID (new grouping of advertiser id - eg: FuneralDirector franchise model)
  };

  if (click_action || event_type === "shortlist") {
    x['metric1'] = '1';
  } else if (event_type === "listview") {
    x['metric3'] = '1';
  } else {
    x['metric2'] = '1';
  }

  if (event_type === 'phone_clicktocall') {
    x['metric4'] = '1';
  }
  if (event_type === 'contact_clicktocall') {
    x['metric5'] = '1';
  }
  if (event_type === 'shortlist')  {
    x['metric6'] = '1';
  }
  if (event_type === 'website_clicktocall' ||
      event_type === 'advertiser-page_click') {
    x['metric7'] = '1';
  }

  //Add hitCallback
  if (typeof hitCallback === "function") {
    x['hitCallback'] = hitCallback;
  }

  return x;
}

function generateTrackEvent(trackData) {
  ga(
    trackData.tracker,
    trackData.hitType,
    trackData.category,
    trackData.action,
    trackData.label,
    trackData.value
  );
}

function generateSocialEvent(trackData) {
  ga(
    trackData.tracker,
    trackData.hitType,
    trackData.socialNetwork,
    trackData.socialAction,
    trackData.socialTarget
  );
}

function generateSubModalEvent(trackData) {
  var x = setup_rnn_x();

  ga(
    trackData.tracker,
    trackData.hitType,
    trackData.category,
    trackData.action,
    x
  );
}

function generateSubPageEvent(trackData){
  ga(
    trackData.tracker,
    trackData.hitType,
    trackData.category,
    trackData.action,
    trackData.label
  );
}

function trackFindaEvent(x, trackData) {
  ga(
    trackData.tracker,
    trackData.hitType,
    trackData.network,
    trackData.event_type,
    0,
    true,
    x
  );
}

function generateFindaEvent(trackData){
  /*
    We don't want to track ads that have no advertisers set in the listview, but we
    still want to track them and all their interactions in the detail view. We track
    everything else.
  */

  var x = setup_finda_x(
    trackData.event_type,
    trackData.click_action,
    trackData.data,
    trackData.hitCallback
  );

  if (trackData.data.ad_advertiser_key !== '0') {
    trackFindaEvent(x, trackData);
  } else {
    if (trackData.event_type !== 'listview') {
      trackFindaEvent(x, trackData);
    }
  }
}
